import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-shared-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent implements OnInit {

  constructor() { }
  @Input() isDialogOpened = false;

  // 點OK按鈕時emit true，Close或Cancel按鈕emit false
  @Output() emitResult = new EventEmitter<boolean>();

  ngOnInit() {
  }

  // 交給父元件用this.isDialogOpened來控制視窗開關，不自己關閉
  // 對話視窗
  onDialogClose(isOk: boolean) {
    this.emitResult.emit(isOk);
  }
}
